const distributions = {
  DISTRIBUTION_LABEL: 'Distributions',

  DISTRIBUTION_TEMPLATE_NAME: 'Plika Template - Distribution ({{date}})',
  DISTIBUTION_DOWNLOAD_TEMPLATE_INFORMATIVE_TOOLTIP_TITLE:
    'You must choose a type of budget and at least a dimension value to be able to download',
}

export default distributions
